import { Button, Col, Form, Modal, Row, Select, Spin, Tooltip, message } from 'antd';
import React, { useEffect, useState } from 'react';
import StAddNew from './DSeries/StAddNew';
import InputIdentify from './InputCreater/InputCreater';
import ZenFormInput from './InputCreater/ZenFormInput';
import { CodeOutlined, DeleteOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import FooterButtons from '../components/STORM/FooterButtons';
import { useSelector } from 'react-redux';
import JsonEditor from 'react-json-editor-ui';
import 'react-json-editor-ui/dist/react-json-editor-ui.cjs.development.css'

const ZenFormBuilder = ({
    setPageHeader
}) => {
    const urlCode = useSelector(state => state.urlCode);
    const [form] = Form.useForm();
    const [smodalForm] = Form.useForm();
    const [zenFormLoading, setZenFormLoading] = useState(false);
    const [smodalLoading, setSmodalLoading] = useState(false);
    const [dictForm] = Form.useForm();
    const [controlJsonData, setControlJsonData] = useState({})
    const [previewForm] = Form.useForm();
    const [groupControl, setGroupControl] = useState(false);
    const [zenFormResponse, setZenFormResponse] = useState();
    const [showVisibleControl, setShowVisibleControl] = useState(true)
    const [modalData, setModalData] = useState({
        open: false,
        typ: '',
        data: null
    });
    const nonEditableControl = ['TypSubTyp', 'TypSubTypDynamic', 'gilDropdown', 'dropDownTree'];
    const [jsonModalData, setJSONModalData] = useState({
        open: false,
        typ: '',
        data: null
    })
    const [selectedControls, setSelectedControls] = useState([]);
    const LocalDict = [];
    const formats = {
        datePicker: 'YYYY-MM-DD',
        rangePicker: 'YYYY-MM-DD',
        dateTimePicker: 'YYYY-MM-DD HH:mm:ss',
        timePicker: 'HH:mm:ss'
    }
    const [formLayout, setFormLayout] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [elementFormLoading, setElementFormLoading] = useState(false);
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const [modalElements, setModalElements] = useState();
    const zenFooterButtons = [
        {
            typ: 'radio',
            label: 'Validate Fields',
            default: 'true',
            data_index: 'buttonProp-validateFields',
            visible: true,
            colSize: 24,
            labelColSize: 10,
            data: {
                true: 'Yes',
                false: 'No'
            }
        },
        {
            typ: 'gilDropdown',
            colSize: 24,
            labelColSize: 10,
            default: 'false',
            data_index: 'buttonProp-hover',
            visible: true,
            label: 'Hover',
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Label On Hover',
                        data_index: 'hoverProp-label',
                        required: true,
                        default: 'Button'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Tooltip On Hover',
                        data_index: 'hoverProp-toolTip',
                        required: true,
                        default: 'Button Hover'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Background Color On Hover',
                        data_index: 'hoverProp-backgroundColor',
                        required: true,
                        default: 'green'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Font Color On Hover',
                        data_index: 'hoverProp-color',
                        required: true,
                        default: '#ffffff'
                    },
                    {
                        typ: 'intControl',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Font Size On Hover',
                        data_index: 'hoverProp-fontSize',
                        required: true,
                        default: 13
                    },
                ]
            }
        },
        {
            typ: 'gilDropdown',
            colSize: 24,
            default: 'false',
            labelColSize: 10,
            visible: true,
            data_index: 'buttonProp-confirmationPopUp',
            label: 'Confirmation Popup',
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Text',
                        required: true,
                        data_index: 'confirmationPopUpProp-text',
                        default: 'Are you sure you want to submit this data?'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'OK Button Label',
                        data_index: 'confirmationPopUpProp-okButtonLabel',
                        default: 'Yes'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Cancel Button Label',
                        data_index: 'confirmationPopUpProp-cancelButtonLabel',
                        default: 'Cancel'
                    },
                ]
            }
        },
        {
            typ: 'gilDropdown',
            colSize: 24,
            default: 'false',
            labelColSize: 10,
            data_index: 'buttonProp-submitFormData',
            visible: true,
            label: 'Submit Form Data',
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'dropDown',
                        labelColSize: 10,
                        colSize: 24,
                        data_index: 'submitFormDataProp-method',
                        default: 'POST',
                        source: 'data',
                        p_data_index: 'submitFormDataProp-p_method',
                        data: {
                            "POST": "POST",
                            "PATCH": "PATCH",
                        },
                        label: 'Method',
                        required: true
                    },
                    {
                        typ: 'textBox',
                        label: 'API URL',
                        labelColSize: 10,
                        colSize: 24,
                        data_index: 'submitFormDataProp-url',
                        default: '/textapi',
                        required: 'true'
                    },
                    {
                        typ: 'textBox',
                        label: 'Params',
                        labelColSize: 10,
                        colSize: 24,
                        data_index: 'submitFormDataProp-params',
                        default: '{"a": "b"}',
                        required: 'true'
                    },
                ]
            }
        },
        {
            typ: 'gilDropdown',
            colSize: 24,
            default: 'false',
            labelColSize: 10,
            label: 'Post Submit Action',
            data_index: 'buttonProp-postSubmitAction',
            visible: true,
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'dropDown',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Action',
                        required: true,
                        source: 'data',
                        default: 'postSubmitActionProp-clearForm',
                        p_data_index: 'postSubmitActionProp-p_action',
                        data_index: 'postSubmitActionProp-action',
                        data: {
                            'clearForm': 'Clear Form',
                            'blankPage': 'Blank Page',
                            'reloadStorm': 'Reload Storm',
                            'newTab': 'New Tab',
                            'reloadPage': 'Reload Page'
                        }
                    },
                    {
                        labelColSize: 10,
                        colSize: 24,
                        typ: 'textBox',
                        data_index: 'postSubmitActionProp-route',
                        default: '/dashboard',
                        required: true,
                        label: 'Route'
                    }
                ]
            }
        },
        {
            typ: 'gilDropdown',
            default: 'false',
            data_index: 'buttonProp-popupModal',
            visible: true,
            label: 'Poppupmodal',
            colSize: 24,
            labelColSpan: 8,
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'dropDown',
                        source: 'dynamic',
                        visible: true,
                        colSize: 24,
                        labelColSpan: 8,
                        label: 'Smodal',
                        isSearchable: true,
                        sourceParams: {
                            typ: 'smodal'
                        }
                    }
                ]
            }

        }
    ];

    useEffect(() => {
        setPageHeader('ZenForm Builder')
    }, []);

    const footerButtonElements = [
        {
            required: true,
            typ: 'textBox',
            label: 'Label',
            data_index: 'label'
        },
        {
            required: true,
            typ: 'dropDown',
            source: 'data',
            data: {
                primary: 'Primary',
                danger: 'Danger'
            },
            label: 'Type',
            data_index: 'type',
            p_data_index: 'p_type'
        },
        {
            required: true,
            typ: 'radio',
            label: 'Enable',
            default: true,
            data_index: 'enable'
        },
        {
            required: true,
            typ: 'radio',
            label: 'Visible',
            default: true,
            data_index: 'visible'
        }
    ]
    const formElements = [
        {
            required: true,
            typ: 'dropDown',
            p_data_index: 'p_typ',
            data_index: 'typ',
            label: 'Control Type',
            source: 'data',
            data: {
                dropDown: 'Dropdown',
                decimalControl: 'Decimal Control',
                textBox: 'TextBox',
                intControl: 'Int Control',
                radio: 'Radio Buttons',
                line: 'Line',
                checkbox: 'CheckBox',
                rangePicker: 'Range Picker',
                datePicker: 'Date Picker',
                // invisibleControl: 'Invisible Control',
                imageControl: 'Image Control',
                fileControl: 'File Control',
                dateTimePicker: 'Date Time Picker',
                timePicker: 'Time Picker',
                label: 'Label',
                TypSubTyp: 'TypSubTyp',
                TypSubTypDynamic: 'TypSubTypDynamic',
                gilDropdown: 'Gil Dropdown',
                gilMultiRow: 'Gil Multi Row',
                gilMultiRowAddNew: 'Gil Multi Row Add New',
                stable: 'Stable',
                imageControlAddNew: 'ImageControl Add New',
                sparkTable: 'sparkTable',
                flameTable: 'Flame Table',
                // dropDownTree: 'DropDown Tree',
                staticDropdownTree: 'StaticDropdownTree',
                //  qcElement: 'QC Element',
                route: 'Route',
                liveDataControl: "Live Data Control"
            }
        },
        {
            required: true,
            typ: 'textBox',
            label: 'Label',
            data_index: 'label'
        },
        {
            required: true,
            typ: 'textBox',
            label: 'Data Index',
            data_index: 'data_index'
        },
        {
            required: true,
            typ: 'intControl',
            label: 'Index',
            data_index: 'indx',
            default: 0
        },
        {
            typ: 'radio',
            required: true,
            label: 'Visible',
            readOnly: true,
            data_index: 'visible',
            default: 'false',
            data: {
                true: 'True',
                false: 'False'
            }
        },
        {
            typ: 'intControl',
            required: true,
            label: 'Col Size',
            default: 13,
            data_index: 'colSize'
        },
        {
            typ: 'intControl',
            required: true,
            label: 'Label Col Size',
            default: 8,
            data_index: 'labelColSpan'
        },
        {
            typ: 'intControl',
            required: true,
            label: 'Blank Space',
            default: 0,
            data_index: 'blankSpace'
        },
    ];

    const addControl = (values) => {
        let specificIndx = '';
        if (values.indx) {
            specificIndx = parseInt(values.indx);
        }
        if (modalData.typ === 'add-footer-btn') {
            delete values.p_type
            let footerBtns = { ...zenFormResponse?.config?.footerButtons };
            let footerBtnName = Object.keys(footerBtns);
            if (footerBtnName.length) {
                let lastBtn = footerBtnName[footerBtnName.length - 1]
                lastBtn = parseInt(lastBtn.split('button')[1]) + 1;
                footerBtns[`button${lastBtn}`] = {
                    buttonProp:
                        values
                }
            } else {
                footerBtns['button1'] = {
                    buttonProp:
                        values
                }
            }
            return saveZenForm({ footerButtons: footerBtns });
        };
        if (modalData.typ === 'edit-footer-btn') {
            let footerBtns = { ...zenFormResponse?.config?.footerButtons };
            let editedBtn = {};
            let dictKeyList = [];
            Object.keys(values).forEach(x => {
                let key = x.split('-')[0];
                if (!dictKeyList.includes(key)) {
                    dictKeyList.push(key);
                }
            });
            dictKeyList.forEach(x => {
                if (x === 'buttonProp') {
                    editedBtn[x] = footerBtns[modalData.data].buttonProp
                }
                Object.keys(values).forEach(y => {
                    if (values[y] === 'true') {
                        values[y] = true;
                    }
                    if (values[y] === 'false') {
                        values[y] = false;
                    }
                    let key = y.split('-')[1];
                    if (y.includes(x)) {
                        editedBtn[x] = {
                            ...editedBtn[x],
                            [key]: values[y]
                        }
                    }
                })
            });
            if (editedBtn.hoverProp) {
                editedBtn.hoverProp.css = {
                    backgroundColor: editedBtn.hoverProp?.backgroundColor,
                    fontSize: editedBtn.hoverProp?.fontSize,
                    color: editedBtn.hoverProp?.color
                };
                delete editedBtn.hoverProp?.backgroundColor;
                delete editedBtn.hoverProp?.color;
                delete editedBtn.hoverProp?.fontSize;
            }
            footerBtns[modalData.data] = editedBtn;
            saveZenForm({ footerButtons: footerBtns })
            return;

        };
        if (values.typ === 'flameTable') {
            values.api = '/textapi';
            values.params = {
                dn: 'FlameTable'
            }
        };
        if (values.typ === 'sparkTable') {
            values.api = '/textapi';
            values.params = {
                dn: 'SparkTable'
            }
        };
        if (values.typ === 'stable') {
            values.api = '/zen/zentable';
            values.params = {
                a: 'b'
            }
        };
        if (values.typ === 'staticDropdownTree') {
            values.api = '/textapi';
            values.params = {
                dn: 'StaticDropdownTree'
            }
        };
        if (values.typ === 'route') {
            values.route = '/zen/chart';
            values.params = {
                a: 'b'
            }
        };
        let blankSpaceVal = parseInt(values.blankSpace);
        //  values.format = formats[values.typ];
        // values.readOnly = values.readOnly === 'true' ? true : false;
        values.visible = values.visible === 'true' ? true : false;
        // values.required = values.required === 'true' ? true : false;
        // values.source = 'data';
        // values.data = {
        //     'test_1': 'Test 1',
        //     'test_2': 'Test',
        // };
        //  values.p_data_index = 'p_' + values.data_index;
        delete values.p_typ;
        delete values.blankSpace;
        if (modalData.typ === 'edit-control') {
            let controls = [...selectedControls];
            controls[modalData.data.index] = values;
            setSelectedControls(controls);
        } else {
            let elementLists = [...selectedControls];
            if (values.typ === 'dropDown') {
                values.source = 'data';
            }
            if (specificIndx) {
                elementLists.splice(specificIndx, 0, values);
                if (blankSpaceVal) {
                    elementLists.splice(specificIndx + 1, 0, {
                        typ: 'blankSpace',
                        colSize: blankSpaceVal,
                        data_index: 'empty_blankSpace',
                        visible: false
                    });
                }
            } else {
                elementLists = [...elementLists, values];
                if (blankSpaceVal) {
                    elementLists = [...elementLists, {
                        typ: 'blankSpace',
                        colSize: blankSpaceVal,
                        data_index: 'empty_blankSpace',
                        visible: false
                    }]
                }
            };
            saveZenForm({ elements: elementLists });
        }
        setElementFormLoading(true);
        closeModal();

    }

    const closeModal = () => {
        setElementFormLoading(true);
        setTimeout(() => {
            smodalForm.resetFields();
            setModalData({
                open: false,
                typ: '',
                data: null
            })
            form.resetFields();
        }, 20);
    }

    const saveZenForm = ({ elements, footerButtons, resolve = () => { }, reject = () => { } }) => {
        setZenFormLoading(true);
        let zenFormData = { ...zenFormResponse };
        if (elements) {
            zenFormData.config.modalElements = elements || [...selectedControls];
        };
        if (footerButtons) {
            zenFormData.config.footerButtons = footerButtons
        }
        zenFormData = { ...zenFormData, typ1: 'zenform' }
        liracrypt.patch('/zenformbuilder', zenFormData)
            .then(response => {
                setZenFormLoading(false);
                setSmodalLoading(false);
                setSelectedControls([]);
                setZenFormResponse(null);
                closeModal();
                closeJSONModal();
                dictForm.submit();
                resolve();
                //  message.success(response.data.message || 'Successfully Created');

            }).catch(err => {
                setSmodalLoading(false);
                reject();
                setZenFormLoading(false);
                ApiErrorComp(err);
            })
    };

    const deleteControl = (index) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this control?',
            okButtonProps: { danger: true },
            okText: 'Yes',
            onOk: () => {
                let elements = [...selectedControls];
                elements = elements.filter((_, i) => i !== index);
                saveZenForm({ elements });
            }
        })
    }

    const deleteFooterBtn = (btn) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this button?',
            okButtonProps: { danger: true },
            okText: 'Yes',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    let footerBtns = { ...zenFormResponse.config.footerButtons };
                    footerBtns[btn].buttonProp.visible = false;
                    footerBtns[btn].buttonProp.enable = false;
                    saveZenForm({ footerButtons: footerBtns, resolve, reject });
                })
            }
        })
    };

    const closeJSONModal = () => {
        setElementFormLoading(true);
        setTimeout(() => {
            setControlJsonData({});
            setJSONModalData({
                open: false,
                data: null
            });
        }, 20);
    }


    const openJSONModal = (data) => {
        console.log(data);
        liracrypt.post('/smodal/zenform', data)
            .then(response => {
                console.log(response);
                let __data = {};
                response.data.config.modalElements.map(x => {
                    __data[x.data_index] = x.default
                })
                setControlJsonData(__data);
            })
            .catch(err => {
                console.log(err);
            })
        let controlData = { ...data };
        delete controlData.dictName;
        delete controlData.zenPreviewListIndex;
        // delete controlData.typ;
        setElementFormLoading(false);
        // setControlJsonData(controlData);
        setTimeout(() => {
            setJSONModalData({
                open: true,
                data: data
            });
        }, 500)
        // liracrypt.get('/smodal/zenform', data)
        //     .then(response => {
        //         console.log(response.data.config.modalElements);
        //         console.log(data);
        //         setControlJsonData(data);
        //         setTimeout(() => {
        //             setJSONModalData({
        //                 open: true,
        //                 data: response.data.data
        //             });
        //         }, 1000)

        //     }).catch(err => {
        //         ApiErrorComp();
        //         console.log(err);
        //     })
    }

    const queryElements = (controls) => {
        return (<Row>
            {
                controls.map((data, index) => {
                    if (dtArray.includes(data["typ"])) {

                        LocalDict[data["data_index"]] = data["format"]
                            ? data["format"]
                            : "YYYY-MM-DD hh:mm:ss";
                        LocalDict["data_index_from"] = data["data_index_from"];
                        LocalDict["data_index_to"] = data["data_index_to"];
                    }
                    if (data.visible || showVisibleControl) {
                        return (
                            <Col className={`zen-preview-control-wrapper ${data.visible ? 'visible-control' : 'invisible-control'}`} span={data.colSize || 12} key={index}>
                                <ZenFormInput
                                    childType={data.childType}
                                    header={data.header}
                                    footer={data.footer}
                                    labelColSpan={data["labelColSpan"]}
                                    style={data['style']}
                                    height={data['height']}
                                    layoutPosition="space-between"
                                    form={form}
                                    LocalDict={LocalDict}
                                    rows={data.rows}
                                    colSpan={24}
                                    name={data["data_index"]}
                                    label={data["label"]}
                                    defaultValue={data["default"]}
                                    typ={data["typ"]}
                                    disabled={data["readOnly"]}
                                    source={data["source"]}
                                    sourceParams={data["sourceParams"]}
                                    auxParams={data["auxParams"]}
                                    format={data["format"]}
                                    errorMessage={data["errorMessage"]}
                                    placeHolder={data["placeHolder"]}
                                    required={data["required"]}
                                    options={data["data"]}
                                    from={data["data_index_from"]}
                                    to={data["data_index_to"]}
                                    url={data["url"]}
                                    includeAll={data["includeAll"]}
                                    pname={data["p_data_index"]}
                                    defaultFrom={data["defaultFrom"]}
                                    defaultTo={data["defaultTo"]}
                                    multiSelect={data["multiSelect"]}
                                    searchable={data["isSearchable"]}
                                    data={data}
                                    //   extraData={extraData}
                                    children={data['children']}
                                />
                                <div className='control-edit-btns' style={{ display: 'flex', alignItems: 'center' }}>
                                    {
                                        nonEditableControl.includes(data.typ) ?
                                            <></> :
                                            <>
                                                <Tooltip title="Edit" color="green">
                                                    <Button
                                                        style={{ marginRight: 10 }}
                                                        onClick={() => {
                                                            setElementFormLoading(false);
                                                            setModalData({
                                                                open: true,
                                                                typ: 'edit-control',
                                                                data: {
                                                                    ...data,
                                                                    zenPreviewListIndex: index
                                                                }
                                                            })
                                                        }}
                                                        type="link"
                                                        icon={
                                                            <EditOutlined style={{ fontSize: 35 }} />
                                                        }
                                                    >{''}</Button>
                                                </Tooltip>
                                                <Tooltip title="Edit JSON" color="green">
                                                    <Button
                                                        style={{ marginRight: 10 }}
                                                        onClick={() => {
                                                            openJSONModal({
                                                                ...data,
                                                                dictName: `ZenFormBuilder_${data.typ}`,
                                                                zenPreviewListIndex: index
                                                            })
                                                        }}
                                                        type="link"
                                                        icon={
                                                            <CodeOutlined style={{ fontSize: 35 }} />
                                                        }
                                                    >{''}</Button>
                                                </Tooltip>
                                            </>
                                    }
                                    <Tooltip title="Delete" color="red">
                                        <Button
                                            style={{ marginLeft: 10, marginRight: 10 }}
                                            onClick={() => {
                                                deleteControl(index)
                                            }}
                                            type="link"
                                            danger={true}
                                            icon={
                                                <DeleteOutlined style={{ fontSize: 35 }} />
                                            }
                                        >{''}</Button>
                                    </Tooltip>
                                    <Tooltip title={data.data_index ? 'Completed' : 'Incomplete'} color={data.visible ? 'green' : 'red'}>
                                        <div className='circle' style={{ height: 20, width: 20, background: data.visible ? 'green' : 'red', marginRight: 10, marginTop: 10 }}></div>
                                    </Tooltip>
                                    <p style={{ color: 'white', marginBottom: 0, marginTop: 10, fontSize: 15 }}>{`[${index}]`}</p>
                                </div>
                            </Col>
                        );
                    }
                })}
        </Row>)
    }

    const onEditFinish = (values, zenPreviewListIndex) => {
        let specificIndx = '';
        if (values.indx?.toString()) {
            specificIndx = parseInt(values.indx);
        }
        if (values.typ === 'dropDown') {
            if (values.source === 'mdict') {
                values.sourceParams = {
                    typ: values.sourceParams_mdict,
                    subTyp: 'idame'
                }
            }

            if (values.source === 'cropdown') {
                values.sourceParams = {
                    name: values.sourceParams_cropdown,
                    // subTyp: 'idame'
                }
            }
        };

        if (values.typ === 'sparkTable' || values.typ === 'flameTable') {
            values.params = {
                dn: values.p_dn
            }
            // delete values.p_dn;
            // delete values.dn;
        };

        if (values.typ === 'liveDataControl') {
            values.params = {
                typ: values.params_typ,
                _id: values.params_id,
                aux1: values.params_aux1,
                subTyp: values.params_subTyp,
            }
        }
        let listIndx = zenPreviewListIndex?.toString() || modalData.data.zenPreviewListIndex
        setSmodalLoading(false);
        let selectedElements = [...selectedControls];
        values = { ...selectedElements[listIndx], ...values };
        if (specificIndx.toString()) {
            selectedElements = selectedElements.filter((_, i) => i !== listIndx);
            selectedElements.splice(specificIndx, 0, values);
            selectedElements.forEach((x, i) => {
                x.indx = i;
            })
        } else {
            let index = selectedElements.findIndex((_, i) => i === parseInt(listIndx));
            selectedElements[index] = values;
        }
        //  setSelectedControls(selectedElements);
        saveZenForm({ elements: selectedElements });
        // liracrypt.patch('/test', values)
        //     .then(({ data }) => {
        //         console.log(data);
        //     }).catch(err => {
        //         ApiErrorComp(err);
        //     })
    }

    const editFooterBtn = (btn, btnLabel) => {
        let footerBtnElements = [...zenFooterButtons];
        Object.keys(btn).forEach(x => {
            let propVal = btn[x];
            Object.keys(propVal).forEach(y => {
                let val = propVal[y];
                if (val === true) {
                    val = 'true';
                }
                if (val === false) {
                    val = 'false';
                };
                let buttonElement = footerBtnElements.find(btnElem => btnElem.data_index === `${x}-${y}`);
                if (buttonElement) {
                    buttonElement.default = val
                };
                setElementFormLoading(false);
                setModalElements(footerBtnElements);
                setModalData({
                    ...modalData,
                    typ: 'edit-footer-btn',
                    open: true,
                    data: btnLabel
                });
                setTimeout(() => {
                    form.setFieldValue(`${x}-${y}`, val);
                }, 500)
            })
        });
    }

    const downloadJson = () => {
        liracrypt.get('/pageconfig/download', { typ1: 'zenform', dictName: zenFormResponse?.config?.dictName, pageconfigId: zenFormResponse?.config?.pageconfigId }).then(({ data }) => {
            if (data.isSuccess) {
                window.open(
                    `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
                    '_blank'
                )
            } else {
                message.error(data.message);
            }
        })
    }


    const onJsonUpload = (values) => {
        setSmodalLoading(true);
        let formData = new FormData();
        formData.append('dictName', zenFormResponse?.config?.dictName);
        formData.append('pageconfigId', zenFormResponse?.config?.pageconfigId);
        formData.append('typ1', "zenform");
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        });
        liracrypt.uploadFile('/pageconfig/upload', formData)
            .then(({ data }) => {
                console.log(data);
                setSmodalLoading(false);
                if (data.isSuccess) {
                    dictForm.submit();
                    closeModal();
                    //    message.success(data.message || 'Successfully Saved');
                } else {
                    message.success(data.message || 'Something went wrong');
                }
            }).catch(err => {
                setSmodalLoading(false);
                console.log(err);
                message.error('Something went wrong');
            })
    }

    const updateZenForm = (values) => {
        if (modalData.typ === 'add-qc' || modalData.typ === 'add-control') {
            addControl(values);
            return;
        }

        if (modalData.typ === 'upload-json') {
            onJsonUpload(values);
            return;
        }
        onEditFinish(values);
    }

    return (
        <div>
            <div className='phantom-form'>
                <StAddNew
                    initForm={dictForm}
                    colSpan={12}
                    stopResetForm={true}
                    urlEndpoint="/miscellaneous/pageconfig"
                    urlData={{ dictName: "ZenFormBuilderStadNew" }}
                    extraData={{}}
                    onCallFinish={({ data }) => {
                        // setControlTyp('all');
                        setZenFormResponse(data);
                        setSelectedControls(data.config.modalElements);
                        setFormLayout(data.config.layout)
                    }}
                />
            </div>
            {
                zenFormResponse ? (
                    <div className={'customer-complaint'} style={{ padding: "10px" }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: 20 }}>
                            <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={() => {
                                setElementFormLoading(false);
                                setModalElements(formElements);
                                setTimeout(() => {
                                    smodalForm.setFieldsValue({ ['indx']: zenFormResponse?.config?.modalElements?.length || 0 })
                                }, 500)
                                setModalData({
                                    ...modalData,
                                    data: {
                                        typ: 'addNewQC'
                                    },
                                    typ: 'add-qc',
                                    open: true
                                })
                            }}>
                                Add New QC Element
                            </Button>
                            <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={() => {
                                setElementFormLoading(false);
                                setModalElements(formElements);
                                setTimeout(() => {
                                    smodalForm.setFieldsValue({ ['indx']: zenFormResponse?.config?.modalElements?.length || 0 })
                                }, 500)
                                setModalData({
                                    ...modalData,
                                    data: {
                                        typ: 'addNewControl'
                                    },
                                    typ: 'add-control',
                                    open: true
                                })
                            }}>
                                Add New Control
                            </Button>
                            <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={() => {
                                setElementFormLoading(false);
                                setModalElements(footerButtonElements);
                                setModalData({
                                    ...modalData,
                                    typ: 'add-footer-btn',
                                    open: true
                                })
                            }}>
                                Add Footer Btn
                            </Button>
                            <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={() => {
                                setShowVisibleControl(!showVisibleControl)
                            }}>
                                {
                                    showVisibleControl ?
                                        'Show Only Visible Controls' :
                                        'Show All controls'
                                }
                            </Button>
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={downloadJson}>
                                Download JSON
                            </Button>
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={() => {
                                setElementFormLoading(false);
                                setModalData({
                                    open: true,
                                    typ: 'upload-json',
                                    data: null
                                })
                            }}>
                                Upload JSON
                            </Button>
                        </div>
                        <div className="customer-form">
                            {/* <h2 style={{ color: 'white' }}>{controlTyp} controls</h2> */}
                            <Form
                                name="zenform-preview"
                                form={previewForm}
                                labelCol={{ span: 8 }}
                                layout={formLayout || "horizontal"}
                                colon={false}
                                onFinish={() => { }}
                                size="large"
                            >
                                {
                                    groupControl ?
                                        selectedControls.map((groupedElement, groupIndex) => (
                                            <>
                                                <p style={groupedElement.header.style}>{groupedElement.header.text}</p>
                                                <div key={groupIndex} className="grouped-zen-form" style={groupedElement.style}>
                                                    {queryElements(groupedElement.controls)}
                                                </div>
                                            </>
                                        )) :
                                        queryElements(selectedControls)
                                }
                                {
                                    zenFormResponse?.config.footerButtons && (
                                        <Row style={{ width: '100%' }} gutter={24} justify="center">
                                            <Col span={24} style={{ display: 'inline-flex', justifyContent: 'center' }}>
                                                {Object.keys(zenFormResponse?.config.footerButtons).map((btn, idx) => {
                                                    const button = zenFormResponse?.config.footerButtons[btn];
                                                    if (button?.buttonProp?.visible || showVisibleControl) {
                                                        return (
                                                            <div className={`zen-preview-control-wrapper ${button?.buttonProp?.visible ? 'visible-control' : 'invisible-control'}`} key={idx}>
                                                                <FooterButtons
                                                                    postSubmitAction={() => { }}
                                                                    openPopupModal={() => { }}
                                                                    button={button}
                                                                    setSelectedButton={() => { }}
                                                                    form={previewForm}
                                                                    label={button?.buttonProp?.label}
                                                                    type={button?.buttonProp?.type}
                                                                    disabled={!button?.buttonProp?.enable}
                                                                    confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                                                    submitFormData={button?.submitFormDataProp}
                                                                />
                                                                <div className='control-edit-btns footer' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Tooltip title="Edit" color="green">
                                                                        <Button
                                                                            style={{ marginRight: 10, color: 'green' }}
                                                                            onClick={() => editFooterBtn(button, btn)}
                                                                            type="link"
                                                                            icon={
                                                                                <EditOutlined style={{ fontSize: 30 }} />
                                                                            }
                                                                        >{''}</Button>
                                                                    </Tooltip>

                                                                    <Tooltip title="Delete" color="red">
                                                                        <Button
                                                                            style={{ marginLeft: 10 }}
                                                                            onClick={() => {
                                                                                deleteFooterBtn(btn)
                                                                            }}
                                                                            type="link"
                                                                            danger={true}
                                                                            icon={
                                                                                <DeleteOutlined style={{ fontSize: 30 }} />
                                                                            }
                                                                        >{''}</Button>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>

                                                        )
                                                    }
                                                })}
                                            </Col>
                                        </Row>
                                    )
                                }
                            </Form>
                        </div>
                    </div>
                ) : <></>
            }

            {
                modalData.open ?
                    <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={modalData.open} title={modalData.typ === 'add-qc' ? "Add New QC Element" : "Zen Form Control"} onCancel={closeModal}>
                        {
                            (modalData.typ === 'add-control' || modalData.typ === 'add-qc' || modalData.typ === 'edit-control' || modalData.typ === 'upload-json') ?
                                elementFormLoading ?
                                    <></> :
                                    <>
                                        <StAddNew
                                            dropdownExtraData={{ stdid: zenFormResponse?.config?.stdid }}
                                            formName="EditZenFormControl"
                                            setSmodalTitle={title => { }}
                                            urlMethod={(modalData.typ === 'upload-json' || modalData.typ === 'add-qc' || modalData.typ === 'add-control') ? 'GET' : 'POST'}
                                            initForm={smodalForm}
                                            colSpan={24}
                                            urlEndpoint={(modalData.typ === 'upload-json' || modalData.typ === 'add-qc' || modalData.typ === 'add-control') ? '/smodal' : '/smodal/zenform'}
                                            extraData={{}}
                                            urlData={modalData.typ === 'upload-json' ? {
                                                dictName: 'ZenFormBuilder_jsonUploader',
                                                pageConfigId: zenFormResponse?.config?.pageconfigId,
                                                selectedDictName: zenFormResponse?.config?.dictName,
                                            } : {
                                                ...modalData.data,
                                                dictName: `ZenFormBuilder_${modalData.data.typ}`
                                            }}
                                            // dictName={currentStep?.smodal?.dictName}
                                            //  pageName={currentStep?.smodal?.pageName}
                                            onFormSubmit={updateZenForm}
                                        />
                                        <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                            <Button loading={smodalLoading} htmlType='submit' type="primary" form={'EditZenFormControl'}>Submit</Button>
                                        </div>
                                    </>
                                :
                                modalData.typ === 'edit-footer-btn' ?
                                    elementFormLoading ? <></> :
                                        <>
                                            <div className={'customer-complaint'} style={{ padding: "10px" }}>

                                                <div className="customer-form">
                                                    <Form
                                                        name={`ReportForm `}
                                                        labelWrap={true}
                                                        form={form}
                                                        labelCol={{ span: 8 }}
                                                        layout={"horizontal"}
                                                        colon={false}
                                                        onFinish={addControl}
                                                        size="large"
                                                    >
                                                        <Row>
                                                            {
                                                                modalElements.map((data, index) => {
                                                                    if (dtArray.includes(data["typ"])) {

                                                                        LocalDict[data["data_index"]] = data["format"]
                                                                            ? data["format"]
                                                                            : "YYYY-MM-DD hh:mm:ss";
                                                                        LocalDict["data_index_from"] = data["data_index_from"];
                                                                        LocalDict["data_index_to"] = data["data_index_to"];
                                                                    }
                                                                    if (data.visible) {
                                                                        return (
                                                                            <ZenFormInput
                                                                                childType={data.childType}
                                                                                header={data.header}
                                                                                footer={data.footer}
                                                                                labelColSpan={data["labelColSpan"]}
                                                                                style={data['style']}
                                                                                height={data['height']}
                                                                                layoutPosition="space-between"
                                                                                form={form}
                                                                                LocalDict={LocalDict}
                                                                                rows={data.rows}
                                                                                colSpan={24}
                                                                                name={data["data_index"]}
                                                                                label={data["label"]}
                                                                                defaultValue={data["default"]}
                                                                                typ={data["typ"]}
                                                                                disabled={data["readOnly"]}
                                                                                source={data["source"]}
                                                                                sourceParams={data["sourceParams"]}
                                                                                auxParams={data["auxParams"]}
                                                                                format={data["format"]}
                                                                                errorMessage={data["errorMessage"]}
                                                                                placeHolder={data["placeHolder"]}
                                                                                required={data["required"]}
                                                                                options={data["data"]}
                                                                                from={data["data_index_from"]}
                                                                                to={data["data_index_to"]}
                                                                                url={data["url"]}
                                                                                includeAll={data["includeAll"]}
                                                                                pname={data["p_data_index"]}
                                                                                defaultFrom={data["defaultFrom"]}
                                                                                defaultTo={data["defaultTo"]}
                                                                                multiSelect={data["multiSelect"]}
                                                                                searchable={data["isSearchable"]}
                                                                                data={data}
                                                                                //   extraData={extraData}
                                                                                children={data['children']}
                                                                            />
                                                                        );
                                                                    }
                                                                })}
                                                        </Row>
                                                        <Row gutter={24} justify="center">
                                                            <Col span={4}>
                                                                {
                                                                    <Button htmlType='submit' type="primary">Submit</Button>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </div>
                                            </div>
                                        </> :
                                    <>
                                        {
                                            elementFormLoading ?
                                                <></> :
                                                <div className={`AuditSection CreateAudit`} style={{ padding: "10px" }}>
                                                    <div className={`ThemeForm ${'phantom'}-form`}>
                                                        <Form
                                                            name={`ReportForm `}
                                                            form={form}
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            layout="horizontal"
                                                            colon={false}
                                                            onFinish={addControl}
                                                            size="large"
                                                        >
                                                            <div
                                                                className="settingModal"
                                                                style={{
                                                                    maxHeight: "400px",
                                                                    overflowY: "scroll",
                                                                    overflowX: "hidden",
                                                                }}
                                                            >
                                                                {
                                                                    modalElements &&
                                                                    modalElements.map((data, index) => {
                                                                        if (dtArray.includes(data["typ"])) {
                                                                            LocalDict[data["data_index"]] = data["format"]
                                                                                ? data["format"]
                                                                                : "YYYY-MM-DD hh:mm:ss";
                                                                            LocalDict["data_index_from"] = data["data_index_from"];
                                                                            LocalDict["data_index_to"] = data["data_index_to"];
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <InputIdentify
                                                                                    //  layoutPosition={layoutPosition}
                                                                                    colSpan={24}
                                                                                    form={form}
                                                                                    name={data["data_index"]}
                                                                                    pname={data["p_data_index"]}
                                                                                    label={data["label"]}
                                                                                    defaultValue={data["default"]}
                                                                                    defaultFrom={data["defaultFrom"]}
                                                                                    defaultTo={data["defaultTo"]}
                                                                                    typ={data["typ"]}
                                                                                    disabled={data["readOnly"]}
                                                                                    source={data["source"]}
                                                                                    sourceParams={data["sourceParams"]}
                                                                                    auxParams={data["auxParams"]}
                                                                                    format={data["format"]}
                                                                                    errorMessage={data["errorMessage"]}
                                                                                    placeHolder={data["placeHolder"]}
                                                                                    required={data["required"]}
                                                                                    options={data["data"]}
                                                                                    from={data["data_index_from"]}
                                                                                    to={data["data_index_to"]}
                                                                                    url={data["url"]}
                                                                                    includeAll={data["includeAll"]}
                                                                                    multiSelect={data["multiSelect"]}
                                                                                    // searchable={data["isSearchable"]}
                                                                                    searchable={true}
                                                                                    data={data}

                                                                                />
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                            </div>
                                                            <Row gutter={24} justify="center">
                                                                <Col span={4}>
                                                                    {
                                                                        <Button htmlType='submit' type="primary">Submit</Button>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    </div>
                                                </div>
                                        }
                                    </>
                        }

                    </Modal> : <></>
            }

            <Modal width={'50%'} style={{ width: '70%' }} maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={jsonModalData.open} title="Edit Control JSON" onCancel={closeJSONModal}>
                {
                    elementFormLoading ?
                        <></> :
                        Object.keys(controlJsonData).length ? (
                            <JsonEditor
                                width={650}
                                data={controlJsonData}
                                onChange={(data) => {
                                    setControlJsonData(data)
                                }}
                                optionsMap={{
                                    color: [
                                        { value: 'red', label: 'Red' },
                                        { value: 'blue', label: 'Blue' },
                                    ],
                                    city: [
                                        { value: 'beijing', label: 'Beijing' },
                                        { value: 'shanghai', label: 'Shanghai' },
                                    ],
                                }}
                            />
                        ) : <></>
                }
                <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                    <Button loading={smodalLoading} onClick={() => onEditFinish(controlJsonData, jsonModalData.data.zenPreviewListIndex)} type="primary" form={'EditZenFormControl'}>Submit</Button>
                </div>
            </Modal>

        </div >
    )
};

export default ZenFormBuilder